import type { PasswordFieldLabels } from '@kilat/ui';

import type { I18n } from './use-i18n.js';

/**
 * Translated label bundle for the shared `@kilat/ui` `PasswordField`.
 *
 * These six strings used to be English DEFAULTS inside the component, and this
 * app — like every other caller — omitted them, so the agent sign-in screen
 * showed "Password", "Show" and "Too short" in English whatever locale the user
 * had chosen. No lint rule can see inside a default parameter value; making the
 * props required is what surfaced it.
 *
 * Keys are the shared `common.password.*` namespace: marketing signup and both
 * sign-in screens render the same field, and per-app copies of the same words
 * drift apart one translation at a time.
 */
export function passwordFieldLabels(t: I18n['t']): PasswordFieldLabels {
  return {
    show: t('common.password.show'),
    hide: t('common.password.hide'),
    showPasswordAria: t('common.password.showAria'),
    hidePasswordAria: t('common.password.hideAria'),
    strength: {
      tooShort: t('common.password.strengthTooShort'),
      gettingThere: t('common.password.strengthGettingThere'),
      solid: t('common.password.strengthSolid'),
      strong: t('common.password.strengthStrong'),
    },
  };
}
